<template>
    <v-card flat>
        <v-overlay :value="loadingPaymentData">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-toolbar color="bal-gray" dense>
            <v-toolbar-title>{{ activePayment.description }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeDrawer()">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab style="text-transform: none !important;">
                {{ "Payment info" | t }}
            </v-tab>
            <v-tab-item> <payment-info-tab /></v-tab-item>
            <v-tab style="text-transform: none !important;">
                {{ "Payment logs" | t }}
            </v-tab>
            <v-tab-item> <payment-logs-tab /></v-tab-item>
            <v-tab style="text-transform: none !important;" v-if="user.role === 'admin'">
                {{ "Bank logs" | t }}
            </v-tab>
            <v-tab-item> <bank-logs-tab /></v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import PaymentInfoTab from "./tabs/payment-info-tab";
import BankLogsTab from "./tabs/bank-logs-tab";
import PaymentLogsTab from "@/views/payment-history/tabs/payment-logs-tab";

export default {
    name: "payment-history-view",
    components: { PaymentLogsTab, PaymentInfoTab, BankLogsTab },
    data() {
        return {
            tab: 0,
            tabs: ["Payment info", "Payment logs"]
        };
    },
    computed: {
        ...mapState(["user"]),
        ...mapState("paymentHistory", ['activePayment', 'loadingPaymentData'])
    },
    async mounted() {
        document.addEventListener("keydown", this.nextTab);
        await this.getPaymentData(this.$route.params.paymentId);
        if (this.user.role === "admin") this.tabs.push("Bank logs");
        if (this.$route.params.tab) {
            this.tab = this.tabs.indexOf(this.$route.params.tab);
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.nextTab);
    },

    methods: {
        ...mapActions("paymentHistory", ["getPaymentData"]),
        closeDrawer() {
            this.$router.push({ name: "payments-history-list" });
        },
        nextTab(e) {
            if (e.key === "ArrowLeft") {
                if (this.tab > 0) {
                    this.tab -= 1;
                }
            } else if (e.key === "ArrowRight") {
                if (this.tab + 1 < this.tabs.length) {
                    this.tab += 1;
                }
            }
        }
    }
};
</script>

<style scoped></style>